import { IconChevronDown } from "@tabler/icons-react";
import { useState } from "react";

type selectOption = {
  id?: string | number;
  value: string | number;
  text: string;
};

type Props = {
  label: string;
  value?: string | number;
  setValue?: Function;
  selectOptions?: selectOption[] | false;
  className?: string;
  classNameLabel?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  errorMsg?: string | null | undefined;
};

export default function SelectInput(props: Props) {
  const [selectOpen, setSelectOpen] = useState(false);

  return (
    <div className={`text-[#1E293B] space-y-2 w-full  ${props?.className}`}>
      <label
        className={`block w-full text-sm ${
          props.disabled ? "opacity-70" : ""
        } ${props?.classNameLabel}`}
      >
        {props.label}
        {props.required && <span className="text-[#DC3545] ml-1">*</span>}
      </label>
      <div className="relative flex items-center justify-between w-full">
        <select
          className={`flex items-center justify-between border rounded-full text-sm p-4 py-2 bg-[#fff] focus:outline-none text-black w-full appearance-none 
    ${props.disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"} 
    ${props.error ? "border-[#DC3545]" : "border-[#d2d2d2] "}`}
          value={props.value}
          onChange={(e) => props.setValue && props.setValue(e.target.value)}
          onClick={() => !props.disabled && setSelectOpen(!selectOpen)}
          disabled={props.disabled}
        >
          <option value={""}>Select</option>
          {props.selectOptions &&
            props.selectOptions?.map((opt, i) => (
              <option key={i + +new Date()} value={opt.value}>
                {opt.text}
              </option>
            ))}
        </select>
        <IconChevronDown
          size={22}
          stroke={2.5}
          className={`absolute right-2 top-2 rotate-0 ${
            selectOpen && "rotate-180"
          } ${props.disabled ? "opacity-50" : ""}`}
        />
      </div>
      {props.error && (
        <small className="text-[#DC3545] text-xs">{props.errorMsg}</small>
      )}
    </div>
  );
}
